import { $, $$ } from '../../../shared/js/utils/dom';
import { Accordion } from '@3pc/accordion';
import { createFocusTrap } from 'focus-trap';

export const initAccordion = container => {
  const handler = $('.accordion__trigger', container);
  const target = $('.accordion__bottom', container);
  const targetInner = $('.accordion__bottom-inner', container);

  const navButtons = $$('.accordion__button', container);
  let focusTrap = null;

  // if no handler or target is found, return
  if (!handler || !target || !targetInner) return;

  const setTabindex = () => {
    navButtons.length &&
      navButtons.forEach(button => {
        !button.hasAttribute('tabindex')
          ? button.setAttribute('tabindex', '-1')
          : button.removeAttribute('tabindex');
      });
  };

  const addFocusTrap = () => {
    focusTrap = createFocusTrap(container, { clickOutsideDeactivates: true });

    focusTrap.activate();
    setTabindex();
  };

  const removeFocusTrap = () => {
    focusTrap.deactivate();
    setTabindex();
  };

  // initialize accordion with options
  const accordion = new Accordion({
    target,
    targetInner,
    handler,
    easing: 'easeInOutQuart',
    duration: 400,
    initOpened: false,
    openClassName: 'is-open',
    closeInstances: [
      /* array of other accordion instances */
    ],
    toggleStart: (element, state, isOpen) => {
      if (isOpen) addFocusTrap();
    },
    toggleEnd: (element, state, isOpen) => {
      if (focusTrap && !isOpen) removeFocusTrap();
    },
  });

  accordion.init();

  return accordion;
};
